module.exports = __webpack_public_path__ + "static/ROIcalculator3-5fbe8721fc903e1f7313b9380f41f53d.png";